import { PickedImage } from '@photosi/expo-photosi-sdk/build/ImageLibrary';

export function pickedImageToString({ file, ...pickedImage }: PickedImage) {
  return JSON.stringify({
    ...pickedImage,
    fileName: file?.name ?? pickedImage.fileName,
    size: file?.size,
    type: file?.type,
  });
}

export function pickedImagesToString(pickedImages: PickedImage[]) {
  return JSON.stringify(pickedImages.map(pickedImageToString));
}
